export default [
    {
        path: '/control-costos-menu',
        name: 'control-costos-menu',
        component: () => import('@/views/pages/controlCostos/ControlCostos.vue'),
        meta: {
            title: 'i18n:Menu',
            resource: 'Control Costos',
            action: 'ver-control-costos-menu',
            pageTitle: 'Control Costos',
            breadcrumb: [
                {
                    text: 'Control Costos',
                },
                {
                    text: 'Menu',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-costos/configuracion/permisos',
        name: 'control-costos-configuracion-permisos',
        component: () => import('@/views/pages/controlCostos/Permisos.vue'),
        meta: {
            title: 'i18n:Permisos',
            resource: 'Control Costos',
            action: 'ver-control-costos-configuracion',
            pageTitle: 'Control Costos',
            breadcrumb: [
                {
                    text: 'Configuracion',
                },
                {
                    text: 'Permisos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/mantenimiento-seccion',
        name: 'mantenimiento-seccion',
        component: () => import('@/views/pages/controlCostos/MantenimientoSeccion.vue'),
        meta: {
            title: 'i18n:Seccion',
            resource: 'Control Costos',
            action: 'ver-control-costos',
            pageTitle: 'Control Costos',
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Seccion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/informe-listado-asistencia',
        name: 'informe-listado-asistencia',
        component: () => import('@/views/pages/controlCostos/ListadoAsistencia.vue'),
        meta: {
            title: 'i18n:Listado de asistencia',
            resource: 'Control Costos',
            action: 'ver-control-costos-informes',
            pageTitle: 'Control Costos',
            breadcrumb: [
                {
                    text: 'Informes',
                },
                {
                    text: 'Listado de asistencia',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-asistencia/mantenimiento/secciones-rh',
        name: 'control-asistencia-mantenimiento-seccion-rh',
        component: () => import('@/views/pages/controlCostos/mantenimiento/SeccionesRH.vue'),
        meta: {
            title: 'i18n:control_asistencia.mantenimiento.seccion.titulo',
            resource: 'Control Costos',
            action: 'ver-control-asistencia-mantenimiento-seccion-rh',
            pageTitle: 'control_asistencia.mantenimiento.seccion.titulo',
            breadcrumb: [
                {
                    text: 'control_asistencia.titulo',
                    active: true,
                },
                {
                    text: 'Mantenimiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-asistencia/configuracion/permisos-seccion',
        name: 'control-asistencia-configuracion-permisos-seccion-rh',
        component: () => import('@/views/pages/controlCostos/configuracion/PermisosSeccionRH.vue'),
        meta: {
            title: 'i18n:control_asistencia.configuracion.permisos_secciones.titulo',
            resource: 'Control Costos',
            action: 'ver-control-asistencia-configuracion-permisos-seccion-rh',
            pageTitle: 'control_asistencia.configuracion.permisos_secciones.titulo',
            breadcrumb: [
                {
                    text: 'control_asistencia.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-asistencia/configuracion/turnos',
        name: 'control-asistencia-configuracion-turnos',
        component: () => import('@/views/pages/controlCostos/configuracion/Turno.vue'),
        meta: {
            title: 'i18n:control_asistencia.configuracion.turnos.titulo',
            resource: 'Control Costos',
            action: 'ver-control-asistencia-configuracion-turnos',
            pageTitle: 'control_asistencia.configuracion.turnos.titulo',
            breadcrumb: [
                {
                    text: 'control_asistencia.titulo',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-asistencia/menu',
        name: 'control-asistencia-menu',
        component: () => import('@/views/pages/controlCostos/MenuAsistencia.vue'),
        meta: {
            title: 'i18n:control_asistencia.menu.titulo',
            resource: 'Control Costos',
            action: 'ver-control-asistencia-menu',
            pageTitle: 'control_asistencia.menu.titulo',
            breadcrumb: [
                {
                    text: 'Control Costos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/control-asistencia/informe/asistencia',
        name: 'control-asistencia-informes-asistencia',
        component: () => import('@/views/pages/controlCostos/informes/InformeAsistencia.vue'),
        meta: {
            resource: 'Control Costos',
            action: 'ver-control-asistencia-informes-asistencia',
            pageTitle: 'Informe de Asistencia',
            breadcrumb: [
                {
                    text: 'Informes',
                },
                {
                    text: 'Informe de asistencia',
                    active: true,
                },
            ],
        },
    },
]
